import React, { useContext, useState } from "react";
import { Button } from "react-bootstrap";
import toast from "react-hot-toast";
import { FaGift, FaWandMagicSparkles } from "react-icons/fa6";
import { claimTrial } from "../../../api/context/billing";
import { SelectionContext } from "../../../Context/Store";

const TrialClaimBanner = ({ trial }) => {
  const { refreshBillingBalance } = useContext(SelectionContext);
  const [loading, setLoading] = useState(false);
  const [burst, setBurst] = useState(false);

  const grantAmount = trial?.grantAmount ?? 3;

  const handleClaim = async () => {
    setLoading(true);
    setBurst(true);
    try {
      const res = await claimTrial();
      const data = res?.data?.data;
      const granted = data?.granted ?? grantAmount;
      toast.success(
        `🎉 You've unlocked ${granted} free credit${granted === 1 ? "" : "s"}!`,
        { duration: 5000 }
      );
      setTimeout(() => refreshBillingBalance(), 250);
    } catch (err) {
      const status = err?.response?.status;
      if (status === 409) {
        toast(
          err?.response?.data?.message ||
            "You have already claimed your free credits.",
          { icon: "ℹ️" }
        );
        refreshBillingBalance();
      } else {
        toast.error("Could not claim trial — please try again");
      }
    } finally {
      setLoading(false);
      setTimeout(() => setBurst(false), 900);
    }
  };

  return (
    <div className={`billing-trial-banner ${burst ? "is-bursting" : ""}`}>
      <div className="billing-trial-glow" aria-hidden="true" />
      <div className="billing-trial-sparkle billing-trial-sparkle--1" aria-hidden="true"><FaWandMagicSparkles /></div>
      <div className="billing-trial-sparkle billing-trial-sparkle--2" aria-hidden="true"><FaWandMagicSparkles /></div>
      <div className="billing-trial-sparkle billing-trial-sparkle--3" aria-hidden="true"><FaWandMagicSparkles /></div>

      <div className="billing-trial-icon">
        <FaGift />
      </div>

      <div className="billing-trial-body">
        <div className="billing-trial-eyebrow">On the house</div>
        <h4 className="billing-trial-title">
          Grab your {grantAmount} FREE AI credits
        </h4>
        <p className="billing-trial-sub">
          Try the AI listing feature — no card required.
        </p>
      </div>

      <div className="billing-trial-cta">
        <Button
          className="billing-trial-btn"
          onClick={handleClaim}
          disabled={loading}
        >
          {loading ? "Claiming..." : "Claim free credits"}
        </Button>
      </div>
    </div>
  );
};

export default TrialClaimBanner;
